export const probestackLoginUrl = 'https://probestack.io/login'
export const probestackLogoutUrl = 'https://probestack.io/logout'

type BrowserLocation = Pick<Location, 'assign' | 'replace' | 'href'>

export function redirectToProbeStackLogin(
  location: BrowserLocation = window.location,
) {
  const loginUrl = new URL(probestackLoginUrl)
  loginUrl.searchParams.set('returnTo', location.href)
  loginUrl.searchParams.set('reauth', '1')
  location.replace(loginUrl.toString())
}

export function redirectToProbeStackLogout(
  location: BrowserLocation = window.location,
) {
  location.assign(probestackLogoutUrl)
}
